import { useQuery } from 'react-query';
import DashboardApiService from '@/modules/dashboard/services/DashboardApiService';
import { FilterFactory, TermFilter } from '@dofleini/query-builder';

export const usePaymentHistogram = (filter, userId) => {
  
  if (userId)
    filter = FilterFactory.add(filter, new TermFilter({ field: 'owner', value: userId, objectId: true }));
  
  return useQuery(
    ['payment-histogram', filter, userId],
    () => DashboardApiService.getPaymentHistogram({ filters: filter }),
    { enabled: !!filter },
  );
};
